import { BodyM } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import CustomConfirmationDialog from 'components/CustomConfirmationDialog/CustomConfirmationDialog';
import React from 'react';

interface ISuccessDialogProps {
	isOpen: boolean;
	hideDialog: () => void;
}

const FailureDialog = ({ isOpen, hideDialog }: ISuccessDialogProps) => {
	return (
		<CustomConfirmationDialog
			isOpen={isOpen}
			isError
			hideDialog={hideDialog}
			header={<BodyM disableMargin>{translate('something.went.wrong')}</BodyM>}
		/>
	);
};

export default FailureDialog;
